import http from '@monolith/legacy/services/api/http';
import { ImportClients } from '../../types/import-clients.types';

export const importClients = (payload): Promise<ImportClients> =>
  http()
    .post(`/api/network/import-clients`, payload)
    .then((response) => response.data);
